import classNames from 'classnames';
import { useAiMetadata } from 'contexts/AIMetadataProvider';
import { FC, useMemo } from 'react';
import { ToastContainer } from 'react-toastify';

const ToastContainerWithOffset: FC = () => {
  const { toastOffset } = useAiMetadata();
  const opacityThreshold = useMemo(
    () => window?.innerHeight * 0.8 || 0,
    [window?.innerHeight],
  );

  return (
    <ToastContainer
      toastClassName={() => 'p-0'}
      className={classNames('p-0 bg-none transition-opacity', {
        'transition-[bottom]': toastOffset === 0,
        'opacity-0': toastOffset > opacityThreshold,
      })}
      style={{ bottom: toastOffset }}
    />
  );
};

export default ToastContainerWithOffset;
